import { API_LOAD_STATUS } from "constants/labels";

export const initialState = {
  supplierDiversityDetails: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [
      {
        RegistrationDate: null,
        CompanyName: null,
        ContactPerson: null,
        EmailAddress: null,
        PhoneNumber: null,
      },
    ],
  },
  supplierState: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: {
      StateId: null,
      StateName: null,
    },
  },
  supplierCategory: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [
      {
        RegisteredSupplier: null,
        NewSupplier: null,
        CertificateExpiring30: null,
        CertificateExpiring60: null,
        CertificateExpiring90: null,
      },
    ],
  },
  supplierSummaryCount: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [
      {
        RegisteredSupplier: null,
        NewSupplier: null,
        CertificateExpiring30: null,
        CertificateExpiring60: null,
        CertificateExpiring90: null,
      },
    ],
  },

  expiringSupplier: {
    Load: { status: API_LOAD_STATUS.PENDING, message: "", errors: [] },
    Succeeded: false,
    Data: [
      {
        UserId: null,
        CompanyName: null,
        EmailAddress: null,
        RegistrationDate: null,
        ExpirationDate: null,
        DaysUntilExpiration: null,
      },
    ],
  },

  expiringInData: {
    Load: { status: API_LOAD_STATUS.PENDING, message: "", errors: [] },
    Succeeded: false,
    Data: [],
  },

  expiringFilterSupplier: {
    Load: { status: API_LOAD_STATUS.PENDING, message: "", errors: [] },
    Succeeded: false,
    Data: [
      {
        RegisteredFrom: null,
        RegisteredTo: null,
        CompanyName: null,
        StateId: null,
        CategoryId: null,
        ExpiringIn: null,
        // Status: data.Status === 0 ? false : data.Status === 1 ? true : null,
      },
    ],
  },

  resisterSupplier: {
    Load: { status: API_LOAD_STATUS.PENDING, message: "", errors: [] },
    Succeeded: false,
    Data: [
      {
        RegisteredFrom: null,
        RegisteredTo: null,
        CompanyName: null,
        StateId: null,
        CategoryId: null,
        // Status: data.Status === 0 ? false : data.Status === 1 ? true : null,
      },
    ],
  },
  businessCategory: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  agency: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  documentType: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  classification: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  state: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  registeredSupplierDownload: {
    Load: { status: API_LOAD_STATUS.PENDING, message: "", errors: [] },
    Succeeded: false,
    Data: [],
  },
};
